
export enum STATUS {

  TEXT = 0, IMAGE, VIDEO, POLL
}

export enum LOGINS {

  EMAIL = 0, GOOGLE, TWITTER, FACEBOOK
}